export const VERSION_CHECK_FREQUENCY = 1800000;
